<template>
  <GcBaseLayout
    :title="screenConfig.title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageRefreshKey"
    :backButtonEnable="backButtonEnable"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="tabsAccessControl"
    :selectedIndex="screenConfig.selectedIndex"
  >
    <template #headerContent>
      <GcHeaderContentStatic
        :title="screenConfig.title"
        :screenName="getScreenName"
      />
    </template>

    <div class="css-v2 transaction-list">
      <GcDataGrid
        :grouping="true"
        :export="true"
        :summary="true"
        :dataSourceConfig="screenConfig.gridData.gridOptions.dataSource"
        :columns="screenConfig.gridData.columns"
        :id="'transaction-list-grid'"
        ref="transactionListGrid"
        :isLocalDataSource="
          !!screenConfig.gridData.gridOptions.dataSource.localDataList
        "
        :isEditableGrid="false"
        :showFooter="false"
        :gridOptions="screenConfig.gridData.gridOptions"
        :rowClick="rowClickCallBack"
        :gridToolbar="screenConfig.gridData.toolbar"
        :exportFileName="screenConfig.exportFileName"
        v-if="loaded && loadDataGrid"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :defaultUserSettings="defaultUserSettings"
        :title="screenConfig.title"
        :save-grid-layout="true"
        :key="gridKey"
      />
    </div>

    <gc-popup
      :popup-visible="gcPopupVisible"
      :popup-title="gcPopupConfig.title"
      :back-button-function="popUpBackButtonClick"
      :popupHeight="'auto'"
      v-if="gcPopupConfig && gcPopupVisible"
      :saveValidation="gcPopUpSaveOption"
      :saveButtonConfig="gcPopupConfig.save"
      :backButtonConfig="gcPopupConfig.back"
      :data-model="gcPopupConfig.dataModel"
      :ref="'transaction-list-grid-form-popup'"
      :id="'transaction-list-grid-form-popup'"
      :popupWidth="
        gcPopupConfig.popupWidth ? gcPopupConfig.popupWidth : undefined
      "
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="gcPopupConfig.formOptions"
          :formItems="gcPopupConfig.items"
          :formHeight="gcPopupConfig.height ? gcPopupConfig.height : 'auto'"
          :isNormal="true"
          :data-model="gcPopupConfig.dataModel ? gcPopupConfig.dataModel : {}"
          :formMode="baseView.mode"
          :validationGroup="'gcPopupConfig-gc-popup-form-data'"
          :formTitle="'gc-popup'"
          v-if="gcPopupConfig.items"
          :valueChangeCallBack="gcPopupConfigValueChangeCallBack"
          :checkValid="gcPopupIsValid"
          :ref="'gcPopupConfig-gc-popup-form-data'"
          formKey="gcPopupConfig-gc-popup-form-data"
          :formContentReady="
            gcPopupConfig.formContentReady
              ? gcPopupConfig.formContentReady
              : () => {}
          "
        ></gc-form>
      </div>
    </gc-popup>

    <GcSundryTransactionPopup
      v-if="gcSundryTransactionPopupConfig.gcPopupVisible"
      :visible="gcSundryTransactionPopupConfig.gcPopupVisible"
      :gcSundryTransactionPopupConfig="gcSundryTransactionPopupConfig"
      :setLoading="showLoading"
      :showValidationSummary="showValidationSummary"
    />

    <GcPopupSoPayNow
      v-if="gcSOPayNowPopupConfig.visible"
      :visible="gcSOPayNowPopupConfig.visible"
      :salesOrderCode="gcSOPayNowPopupConfig.salesOrderCode"
      :customerName="gcSOPayNowPopupConfig.customerName"
      :customerCode="gcSOPayNowPopupConfig.customerCode"
      :orderAmount="gcSOPayNowPopupConfig.orderAmount"
      :callback="gcSOPayNowPopupConfig.callback"
      :setLoading="showLoading"
    />

    <GcPopupSoPartPick
      v-if="gcSOPartPickPopupConfig.visible"
      :visible="gcSOPartPickPopupConfig.visible"
      :salesOrderCode="gcSOPartPickPopupConfig.salesOrderCode"
      :customerName="gcSOPartPickPopupConfig.customerName"
      :shipDate="gcSOPartPickPopupConfig.shipDate"
      :requiredByDate="gcSOPartPickPopupConfig.requiredByDate"
      :callback="gcSOPartPickPopupConfig.callback"
      :setLoading="showLoading"
      :customerCode="gcSOPartPickPopupConfig.customerCode"
    />

    <GcPopupBankTransfer
      v-if="gcPopupBankTransferConfig.visible"
      :visible="gcPopupBankTransferConfig.visible"
      :callback="gcPopupBankTransferConfig.callback"
      :showValidationSummary="showValidationSummary"
      :setLoading="showLoading"
    />

    <GcPopupCustomerStatement
      v-if="gcPopupCustomerStatementConfig.visible"
      :setVisible="gcPopupCustomerStatementConfig.visible"
      :hidden="gcPopupCustomerStatementConfig.hidden"
      :showLoading="showLoading"
      :dataObj="gcPopupCustomerStatementConfig.dataModel"
      :displayValidationSummary="displayValidationSummary"
    />

    <GcPopupCustomerProductHistoryDtl
      v-if="gcPopupCustomerProductHistoryDtlConfig.visible"
      :setVisible="gcPopupCustomerProductHistoryDtlConfig.visible"
      :hidden="gcPopupCustomerProductHistoryDtlConfig.hidden"
      :setLoading="showLoading"
      :dataObj="gcPopupCustomerProductHistoryDtlConfig.dataModel"
      :columns="gcPopupCustomerProductHistoryDtlConfig.columns"
      :filters="gcPopupCustomerProductHistoryDtlConfig.filters"
    />

    <GcPopupDepositClaim
      v-if="gcPopupDepositClaimConfig.visible"
      :setVisible="gcPopupDepositClaimConfig.visible"
      :callBack="gcPopupDepositClaimConfig.callback"
      :salesOrderData="gcPopupDepositClaimConfig.data"
      :setLoading="showLoading"
    />

    <GcPopupSSCC
      v-if="gcPopupSSCCConfig.visible"
      :setVisible="gcPopupSSCCConfig.visible"
      :hidden="gcPopupSSCCConfig.hidden"
      :showLoading="showLoading"
      :dataObj="gcPopupSSCCConfig.dataModel"
    />

    <GcPopupPalletDetail
      v-if="gcPopupPalletDetailConfig.visible"
      :setVisible="gcPopupPalletDetailConfig.visible"
      :hidden="gcPopupPalletDetailConfig.hidden"
      :showLoading="showLoading"
      :dataObj="gcPopupPalletDetailConfig.dataModel"
    />

    <gcPopupSaveLayout
      :visible.sync="getVisibleGridSavePopup"
      :persistenceKey="persistenceKey"
      :showLoading="showLoading"
      :original-columns="[...deepCloneColumns]"
      v-if="getVisibleGridSavePopup"
    />

    <slot name="popup" />
    <slot name="hiddencontent" />
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { tabAccessControl } from "@/_helpers/access-control";
import { mapGetters } from "vuex";
import { TransactionListService } from "@/_services/api/templates/transactions-list.services";
import { CacheService } from "@/_services/cache/cache-service";
import GcPopupSoPayNow from "../popups/gc-popup-so-pay-now.vue";
import { CommonStorage, FeatureStorage } from "../_services/storage";
import { DataGridState } from "../_models/data-grid-state";
import gcPopupSaveLayout from "../popups/data-grid/gc-popup-save-layout.vue";
import DataGridHelpers from "@/_helpers/data-grid/helpers";
const { syncDateFilters } = DataGridHelpers;
import GcPopupCustomerStatement from "../popups/customers/gc-popup-customer-statement.vue";

/**
 * TODO - Move out the unused Popup and use the slot instead
 */
export default {
  props: {
    gcPopupDepositClaimConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    screenConfig: {
      type: Object,
      default: undefined,
    },
    rowClick: {
      type: Function,
      default: () => {},
    },
    setLoading: {
      type: Boolean,
      default: false,
    },
    persistenceKey: {
      type: String,
    },
    gcPopupConfig: {
      type: Object,
      default: () => {},
    },
    loadDataGrid: {
      type: Boolean,
      default: true,
    },
    gcSundryTransactionPopupConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcSOPayNowPopupConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcSOPartPickPopupConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcPopupCustomerStatementConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcPopupCustomerProductHistoryDtlConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcPopupPalletDetailConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcPopupBankTransferConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcPopupSSCCConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    backButtonRoute: {
      type: String,
      default: "/home",
    },

    backButtonEnable: {
      type: Boolean,
      default: false,
    },
    defaultUserSettings: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [RouteMixin, FormMixin],
  components: { GcPopupSoPayNow, gcPopupSaveLayout, GcPopupCustomerStatement },
  data() {
    return {
      loaded: false,
      gcPopupVisible: false,
      isValid: false,
      pageRefreshKey: new Date().getTime(),
      gcPopupIsValid: false,
      gridKey: new Date().getTime(),
    };
  },
  beforeDestroy() {
    this.loaded = false;
  },
  computed: {
    deepCloneColumns() {
      return JSON.parse(JSON.stringify(this.screenConfig.gridData.columns));
    },
    ...mapGetters({
      getTriggerViewDefinitionChange:
        "gridViewDefinition/getTriggerViewDefinitionChange",
    }),
    ...mapGetters({ getHotKeyCreateNew: "hotKey/getHotKeyCreateNew" }),
    ...mapGetters({ displayServerErrorPopUp: "ui/getServerError" }),
    ...mapGetters({ visibleGridSavePopup: "ui/getVisibleGridSavePopup" }),
    ...mapGetters({
      getSelectedDefinitionByKey:
        "gridViewDefinition/getSelectedDefinitionByKey",
    }),
    tabsAccessControl() {
      if (this.screenConfig.tabs)
        return tabAccessControl(this.screenConfig.tabs);
      else return [];
    },
    getScreenName() {
      if (this.screenConfig.ScreenName) return this.screenConfig.ScreenName;
      else if (this.screenConfig.tabs && this.screenConfig.title) {
        return (
          this.screenConfig.title +
          " - " +
          this.screenConfig.tabs[this.screenConfig.selectedIndex].text
        );
      } else return undefined;
    },
    getVisibleGridSavePopup: {
      get() {
        return this.visibleGridSavePopup;
      },
      set(val) {
        this.$store.dispatch("ui/setVisibleGridSavePopup", val);
      },
    },
  },
  async beforeMount() {
    this.$store.dispatch("defaultDateSettings/setCurrentFiscalData");
    this.pageRefreshKey = new Date().getTime();

    const removeState = CommonStorage.getItems("remove_state");

    if (this.persistenceKey) {
      // await DataGridState.checkInDatabase(this.persistenceKey);
      DataGridState.initializeGridViewDefinition(this.persistenceKey, [
        ...this.screenConfig.gridData.columns,
      ]);
    } else if (removeState === "true") {
      await DataGridState.removeState(this.persistenceKey);
    }
    CommonStorage.saveItems("remove_state", false);
  },

  async created() {
    if (this.screenConfig.ScreenName) this.getReportPreviewScreenName();
    else this.loaded = true;

    if (
      this.screenConfig.gridData.toolbar.screenName &&
      (this.screenConfig.gridData.toolbar.pdf === true ||
        this.screenConfig.gridData.toolbar.multiplePdf === true)
    )
      this.$store.dispatch("reportPdfPreview/setReportPreviewScreens");
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
    showValidationSummary(val) {
      if (val.length > 0) {
        this.displayValidationSummary(val);
      }
    },
    gcPopUpSaveOption() {
      this.gcPopupIsValid = true;
    },
    gcPopupConfigValueChangeCallBack(isValid, brokenRules) {
      this.gcPopupIsValid = false;
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.gcPopupConfig.save.clickCallback(
          this.gcPopupConfig.dataModel ? this.gcPopupConfig.dataModel : {},
        );
      }
    },
    popUpBackButtonClick() {
      this.gcPopupVisible = false;
      if (this.gcPopupConfig) this.gcPopupConfig.callBack();
    },
    async getReportPreviewScreenName() {
      var data = [];

      if (CacheService.getCache("ReportPreviewScreens")) {
        data = CacheService.getCache("ReportPreviewScreens").filter(
          (x) => x.ScreenName === this.screenConfig.ScreenName,
        );
      } else {
        await TransactionListService.getReportPreviewScreens()
          .then((res) => {
            CacheService.saveCache("ReportPreviewScreens", res.data.value, 5);
            data = res.data.value.filter(
              (x) => x.ScreenName === this.screenConfig.ScreenName,
            );
          })
          .catch((err) => {
            if (err) this.getReportBackgroundScreenName();
          });
      }

      var index = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField === "GridRecordPDFView",
      );
      if (index !== -1) {
        let pdfPreviewData = data.filter(
          (x) => x.AvailableForPDFPreview === "Y",
        );
        this.screenConfig.gridData.columns[index].PrintPreview = pdfPreviewData;
        if (data.length === 0 || pdfPreviewData.length === 0)
          this.screenConfig.gridData.columns[index].visible = false;
      }

      var emailColumnIndex = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField === "GridRecordEmail",
      );

      if (emailColumnIndex !== -1) {
        let emailData = data.filter((x) => x.AvailableForEmail === "Y");

        const CofA = emailData.find(
          (x) => x.ScreenLayoutApplicationFeatureCode === "ReportCofA",
        );

        if (CofA) {
          const permission = FeatureStorage.checkPermission(
            CofA.ScreenLayoutApplicationFeatureCode,
            "create",
          );

          if (!permission) {
            emailData = emailData.filter(
              (x) => x.ScreenLayoutApplicationFeatureCode !== "ReportCofA",
            );
          }
        }

        this.screenConfig.gridData.columns[emailColumnIndex].BackgroundEmail =
          emailData;
        if (data.length === 0 || emailData.length === 0)
          this.screenConfig.gridData.columns[emailColumnIndex].visible = false;
      }

      this.getReportBackgroundScreenName();
    },
    async getReportBackgroundScreenName() {
      var data = [];

      if (CacheService.getCache("ReportBackgroundScreens")) {
        data = CacheService.getCache("ReportBackgroundScreens").filter(
          (x) => x.ScreenName === this.screenConfig.ScreenName,
        );
      } else {
        await TransactionListService.getReportBackgroundScreens({
          select: [
            "RecordID",
            "ReportDisplayName",
            "ScreenName",
            "Status",
            "TransactionCode",
          ],
        })
          .then((res) => {
            CacheService.saveCache(
              "ReportBackgroundScreens",
              res.data.value,
              5,
            );
            data = res.data.value.filter(
              (x) => x.ScreenName === this.screenConfig.ScreenName,
            );
          })
          .catch((err) => {
            if (err) this.loaded = true;
          });
      }

      var index = this.screenConfig.gridData.columns.findIndex(
        (x) => x.screenField === "GridRecordPrint",
      );
      if (index !== -1) {
        this.screenConfig.gridData.columns[index].BackgroundPrint = data;
        if (data.length === 0)
          this.screenConfig.gridData.columns[index].visible = false;
      }

      this.loaded = true;
    },

    rowClickCallBack(e) {
      if (this.screenConfig.gridData.gridOptions.rowSelect)
        this.onRowClicked(e, this.screenConfig.gridData.gridOptions.rowSelect);
      else this.rowClick(e);
    },
  },
  watch: {
    getHotKeyCreateNew(value) {
      if (value) {
        this.$store.dispatch("hotKey/setHotKeyCreateNew", false);
        if (
          this.screenConfig &&
          this.screenConfig.gridData &&
          this.screenConfig.gridData.toolbar
        ) {
          if (this.screenConfig.gridData.toolbar.customButtons) {
            var customButtons =
              this.screenConfig.gridData.toolbar.customButtons;
            var addNew = customButtons.filter(
              (x) => x.icon === "plus" || x.label === "Add New",
            );
            if (addNew.length > 0) {
              this.setIgnoreRouteChangeConfirmation();
              var element = addNew[0];
              if (element.routeAction)
                this.$router.push({
                  path: element.routeAction(),
                  query: element.routeQuery ? element.routeQuery : undefined,
                });
              else if (
                element.clickAction &&
                typeof element.clickAction === "function"
              )
                element.clickAction();
              else
                this.$router.push({
                  path: element.route,
                  query: element.routeQuery ? element.routeQuery : undefined,
                });
            }
          }
        }
      }
    },
    displayServerErrorPopUp(val) {
      if (val) {
        this.displayServerError(val.error, val.title);
      }
    },
    setLoading(val) {
      this.showLoading(val);
    },
    gcPopupConfig: {
      handler(val) {
        if (this.gcPopupVisible !== val.gcPopupVisible)
          this.gcPopupVisible = val.gcPopupVisible;
      },
      deep: true,
    },
    getTriggerViewDefinitionChange: {
      handler(value) {
        if (value) {
          this.$store.dispatch(
            "gridViewDefinition/setTriggerViewDefinitionChange",
            false,
          );

          const selectedDefinition = this.getSelectedDefinitionByKey(
            this.persistenceKey,
          );
          if (selectedDefinition) {
            if (selectedDefinition.GridDefinition) {
              const GridDefinition = JSON.parse(
                selectedDefinition.GridDefinition,
              );
              if (GridDefinition) {
                CommonStorage.saveItems(
                  this.persistenceKey,
                  JSON.stringify(GridDefinition),
                );
              }
            }

            if (selectedDefinition.FilterDefinition) {
              const FilterDefinition = JSON.parse(
                selectedDefinition.FilterDefinition,
              );
              if (FilterDefinition) {
                const syncedFilterDefinition = syncDateFilters(
                  FilterDefinition,
                  this.deepCloneColumns,
                );
                CommonStorage.saveItems(
                  "filter-panel-" + this.persistenceKey,
                  JSON.stringify(syncedFilterDefinition),
                );
              }
            } else {
              CommonStorage.clear("filter-panel-" + this.persistenceKey);
            }

            this.$nextTick(() => {
              if (this.$refs["transactionListGrid"]) {
                this.gridKey = new Date().getTime();
              }
            });
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss"></style>
